<svg width="100%" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.50087 0H1.54489C0.659451 0 0.210848 1.06585 0.829791 1.69903L4.80778 5.76847C5.20006 6.16976 5.84569 6.16976 6.23797 5.76847L10.216 1.69903C10.8349 1.06585 10.3863 0 9.50087 0Z" fill="#45586B"/>
</svg>
